import MutateLink from "./MutateLink";

export default MutateLink